const TASK_STATUS_TYPES = [
  { id: 'OPEN', text: 'Offen'},
  { id: 'IN_PROGRESS', text: 'In Bearbeitung'},
  { id: 'FINISHED', text: 'Abgeschlossen'},
]
  
  export default TASK_STATUS_TYPES;